module.exports = __webpack_public_path__ + "static/media/video-retraining-zh.0c7ebb7a.vtt";